import type {
  JobAdFacetPropertiesFromAlgolia,
  JobAdFacetValuesFromAlgolia,
} from "@/modules/jobAds/types/jobAdFromAlgolia"

export const formatAlgoliaFacetValue = (
  algoliaFacetProperty: JobAdFacetPropertiesFromAlgolia,
  algoliaFacetValue: JobAdFacetValuesFromAlgolia,
  facultySchoolId: string | undefined,
  schoolId: string
  // eslint-disable-next-line max-params
): string[] => {
  if (algoliaFacetProperty === "TAGS") {
    return [
      algoliaFacetValue.replace("<school_uuid>", schoolId),
      ...(facultySchoolId && facultySchoolId !== ""
        ? [algoliaFacetValue.replace("<school_uuid>", facultySchoolId)]
        : []),
    ]
  }

  return [algoliaFacetValue]
}
